import { LocalRelayKeyStore, type RelayKeyStore } from "./keystore";
import { keyAccount, sameRoute, type RelayRoute } from "./route";
import { RelayTunnel, type WebSocketFactory } from "./tunnel";

/** 每台主机（每个身份）共用一条隧道：HTTP、文件下载和对话 WebSocket 都复用它（只握手一次）。 */
export class RelayHub {
  private tunnels = new Map<string, RelayTunnel>();
  keyStore: RelayKeyStore;
  /** 主机上 `devices` 命令里显示的名字 */
  deviceName = "浏览器";
  makeSocket?: WebSocketFactory;

  constructor(keyStore?: RelayKeyStore) {
    this.keyStore = keyStore ?? (typeof localStorage !== "undefined" ? new LocalRelayKeyStore() : undefined)!;
  }

  tunnel(route: RelayRoute): RelayTunnel {
    const account = keyAccount(route);
    const existing = this.tunnels.get(account);
    if (existing && sameRoute(existing.route, route)) return existing;
    existing?.suspend();
    const t = new RelayTunnel(route, this.keyStore, this.deviceName, this.makeSocket);
    this.tunnels.set(account, t);
    return t;
  }

  /** 提前建好隧道（回到前台时），和其他启动工作并行。 */
  prewarm(route: RelayRoute): void {
    this.tunnel(route).connect().catch(() => {});
  }

  suspendAll(): void {
    for (const t of this.tunnels.values()) t.suspend();
  }

  checkAll(): void {
    for (const t of this.tunnels.values()) t.checkAlive();
  }

  /** 取消配对：丢掉本机密钥和隧道。 */
  forget(route: RelayRoute): void {
    const account = keyAccount(route);
    this.tunnels.get(account)?.suspend();
    this.tunnels.delete(account);
    this.keyStore.removeKey(account);
  }
}

export const relayHub = new RelayHub();
